import { Box } from '@domain-group/suit-theme'

import Preview from '@components/AttachmentPreview'

import type { UseMediaReviewerOrderItemPayload } from '../hooks/useMediaReviewerOrderItem'

import Actions from './AttachmentPreviewActions'

interface AttachmentPreviewProps {
  orderItemPayload: UseMediaReviewerOrderItemPayload,
}

const AttachmentPreview = (props: AttachmentPreviewProps) => {
  const { orderItemPayload } = props

  const {
    attachmentType,
    callbacks,
    carouselPayload,
    commentMode,
    selectedAttachment,
    service,
  } = orderItemPayload

  return (
    <Box
      borderBottom={!commentMode ? '1px solid' : null}
      borderColor="lineColor"
      flexDirection="column"
      paddingBottom={!commentMode ? 'large' : 'none'}
    >
      {/*
       // @ts-expect-error TS2741 */}
      <Preview
        attachment={selectedAttachment}
        attachmentType={attachmentType}
        carouselPayload={carouselPayload}
      />

      {/*
       Not ideal but requires large rework of use useOrderItem to resolve
       // @ts-expect-error TS2741 */}
      <Actions attachment={selectedAttachment} service={service} callbacks={callbacks} />
    </Box>
  )
}

export default AttachmentPreview
